export const teamAccessUrlDomain = process.env.REACT_APP_CURRENT_BRANCH === 'master'
  ? 'https://team.lifebonus.health/log-in#code='
  : 'https://team-dev.lifebonus.health/log-in#code=';